import { FormsModule } from '@angular/forms';
import { PasswordRevealModule } from 'NewAngular/features/components/password-controls/password-reveal/password-reveal.module';
import { ImageModule } from 'NewAngular/features/directives/image/image.module';
import * as i0 from "@angular/core";
export class PasswordResetModule {
}
PasswordResetModule.ɵfac = function PasswordResetModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || PasswordResetModule)(); };
PasswordResetModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: PasswordResetModule });
PasswordResetModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [ImageModule, PasswordRevealModule, FormsModule] });
